import { useQuery } from '@tanstack/react-query'

import { getStates } from '@/services/project-adress'

export const GET_STATES_QUERY = ['states']

export function useGetAddressStates() {
  const query = useQuery({
    queryKey: [...GET_STATES_QUERY],
    queryFn: () => getStates(),
    staleTime: 1000 * 60 * 60 * 24,
  })

  return query
}
